import PortalVue from 'portal-vue'
import {createApp} from 'vue';

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import {formatDate} from "./Services/DateUtils";
import Panel from './Components/Login/Panel.vue'
import axios from "axios";
import ToggleSwitch from "./Components/UI/ToggleSwitch.vue";
import SimplePagination from "./Components/UI/SimplePagination.vue";
import SearchInput from "./Components/UI/SearchInput.vue";
import FileUpload from "./Components/UI/FileUpload.vue";
import LockBatteryStatus from "./Components/LockBatteryStatus.vue";
import CentreLowBatteryWarning from "./Components/CentreLowBatteryWarning.vue";
import IQNetworkDetails from "./Components/IQNetworkDetails.vue";
import EventLogViewer from "./Components/EventLogViewer.vue";
import EventLogBrowser from "./Components/EventLogBrowser.vue";
import ManageBookingAccessModal from "./Components/ManageBookingAccessModal.vue";
import CompanyManageAccessComponent from "./Components/CompanyManageAccessComponent.vue";
import UserSearchComponent from "./Components/UserSearchComponent.vue";
import TagRegistrationWidget from "./Components/Maintenance/TagRegistrationWidget.vue";
import CentreSyncManager from "./Components/Sync/CentreSyncManager.vue";
import ManualSyncTriggerButton from "./Components/Sync/ManualSyncTriggerButton.vue";
import GlobalConfigurationComponent from "./Components/GlobalConfigurationComponent.vue";
import CentreConfigurationComponent from "./Components/CentreConfigurationComponent.vue";
import CentreToggleSwitch from "./Components/CentreToggleSwitch.vue";
import SharedUserSearchComponent from "./Components/Shared/UserSearchComponent.vue";
import UserFillerComponent from "./Components/Shared/UserFillerComponent.vue";
import NewVisitorAccessFormComponent from "./Components/NewVisitorAccessFormComponent.vue";
import ContractorAccessFormComponent from "./Components/ContractorAccessFormComponent.vue";
import FormCancellationButton from "./Components/UI/FormCancellationButton.vue";
import FormSenderButton from "./Components/UI/FormSenderButton.vue";
import ValidationError from "./Components/UI/ValidationError.vue";
import AccessRequestsTableComponent from "./Components/AccessRequestsTableComponent.vue";
import ContractorAccessTableComponent from "./Components/ContractorAccessTableComponent.vue";
import CustomAccessFormComponent from "./Components/CustomAccessFormComponent.vue";
import ApprovalRequestRejectionButton from "./Components/ApprovalRequestRejectionButton.vue";
import CentreSelectComponent from "./Components/CentreSelectComponent.vue";
import RemovalTableComponent from "./Components/Tools/RemovalTableComponent.vue";
import ELockComponent from "./Components/RemoteAccess/ELockComponent.vue";
import FormComponent from "./Components/RemoteAccess/FormComponent.vue";
import TableComponent from "./Components/RemoteAccess/TableComponent.vue";
import OfflineAccessForLockDataTable from "./Components/UI/OfflineAccessForLockDataTable.vue";
import UsersDataTable from "./Components/UI/UsersDataTable.vue";
import FutureAccessDataTable from "./Components/UI/FutureAccessDataTable.vue";
import CompanyBasedAccessDataTable from "./Components/UI/CompanyBasedAccessDataTable.vue";
import CentreUsersDataTable from "./Components/UI/CentreUsersDataTable.vue";
import OfflineAccessForUserDataTable from "./Components/UI/OfflineAccessForUserDataTable.vue";
import CompaniesDataTable from "./Components/UI/CompaniesDataTable.vue";
import BusinessLoungeAccessDataTable from "./Components/UI/BusinessLoungeAccessDataTable.vue";
import CentreStaffDataTable from "./Components/UI/CentreStaffDataTable.vue";
import CentresDataTable from "./Components/UI/CentresDataTable.vue";
import CustomAccessDataTable from "./Components/UI/CustomAccessDataTable.vue";
import AccessDataTable from "./Components/UI/AccessDataTable.vue";
import UserCentreSelectComponent from "./Components/UserCentreSelectComponent.vue";
import LaravelVuePagination from "laravel-vue-pagination";
import BaseTabs from "./Components/UI/Tabs/BaseTabs.vue";
import BaseTab from "./Components/UI/Tabs/BaseTab.vue";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);

const app = createApp({});

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

console.log("========================");
console.log("Access Control App");
console.log("(c) Clay Solutions BV - A Salto company - 2019");
console.log("========================");

app.use(PortalVue);

app.component('toggle-switch', ToggleSwitch);
app.component('simple-pagination', SimplePagination);
app.component('search-input', SearchInput);
app.component('file-uploader', FileUpload);

app.component('lock-battery-status', LockBatteryStatus);
app.component('centre-low-battery-warning', CentreLowBatteryWarning);
app.component('iq-network-details', IQNetworkDetails);
app.component('event-log-viewer', EventLogViewer);
app.component('event-log-browser', EventLogBrowser);
app.component('manage-booking-access-modal', ManageBookingAccessModal);
app.component('company-manage-access-component', CompanyManageAccessComponent);
app.component('user-search-component-modal', UserSearchComponent);
app.component('tag-registration-widget', TagRegistrationWidget);
app.component('centre-sync-manager', CentreSyncManager);
app.component('manual-sync-trigger-button', ManualSyncTriggerButton);
app.component('global-configuration-component', GlobalConfigurationComponent);
app.component('centre-configuration-component', CentreConfigurationComponent);
app.component('centre-toggle-switch', CentreToggleSwitch);
app.component('user-search-component', SharedUserSearchComponent);
app.component('user-filler-component', UserFillerComponent);
app.component('new-visitor-access-form-component', NewVisitorAccessFormComponent);
app.component('contractor-access-form-component', ContractorAccessFormComponent);
app.component('form-cancellation-button', FormCancellationButton);
app.component('form-sender-button', FormSenderButton);
app.component('validation-error', ValidationError);
app.component('access-requests-table', AccessRequestsTableComponent);
app.component('contractor-access-table', ContractorAccessTableComponent);
app.component('custom-access-form-component', CustomAccessFormComponent);
app.component('approval-request-rejection-button', ApprovalRequestRejectionButton);
app.component('centre-select-component', CentreSelectComponent);
app.component('tool-removal-table', RemovalTableComponent);
app.component('remote-access-elock-component', ELockComponent);
app.component('remote-access-form-component', FormComponent);
app.component('remote-accesses-table', TableComponent);
app.component('offline-access-for-lock-data-table', OfflineAccessForLockDataTable);
app.component('users-data-table', UsersDataTable);
app.component('future-access-data-table', FutureAccessDataTable);
app.component('company-based-access-data-table', CompanyBasedAccessDataTable);
app.component('centre-users-data-table', CentreUsersDataTable);
app.component('offline-access-for-user-data-table', OfflineAccessForUserDataTable);
app.component('companies-data-table', CompaniesDataTable);
app.component('business-lounge-access-data-table', BusinessLoungeAccessDataTable);
app.component('centre-staff-data-table', CentreStaffDataTable);
app.component('centres-data-table', CentresDataTable);
app.component('custom-access-data-table', CustomAccessDataTable);
app.component('access-data-table', AccessDataTable);
app.component('user-centre-select-component', UserCentreSelectComponent);

app.component('pagination', LaravelVuePagination);

app.config.globalProperties.$formatDate = formatDate;

if (document.getElementById('vue-app')) {
    app.mount('#vue-app');
}

if (document.getElementById('grid-app')) {
    const gridApp = createApp({});
    gridApp.mount('#grid-app');
}

if (document.getElementById('tabs-app')) {
    const tabsApp = createApp({});
    tabsApp.component('base-tabs', BaseTabs);
    tabsApp.component('base-tab', BaseTab);
    tabsApp.component('access-data-table', AccessDataTable);
    tabsApp.component('future-access-data-table', FutureAccessDataTable);
    tabsApp.component('business-lounge-access-data-table', BusinessLoungeAccessDataTable);
    tabsApp.component('offline-access-for-user-data-table', OfflineAccessForUserDataTable);
    tabsApp.component('event-log-browser', EventLogBrowser);
    tabsApp.component('pagination', LaravelVuePagination);
    tabsApp.component('user-centre-select-component', UserCentreSelectComponent);
    tabsApp.config.globalProperties.$formatDate = formatDate;
    tabsApp.mount("#tabs-app");
}

if (document.getElementById('login')) {
    const loginApp = createApp({});
    loginApp.component('panel', Panel);
    loginApp.mount('#login');
}
